import React, { memo, useCallback } from "react";
import PropTypes from "prop-types";
import {
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Icon,
  IconButton,
} from "@chakra-ui/react";
import { FaSearch, FaTimes } from "react-icons/fa";

const SearchInput = React.forwardRef(
  ({ disabled, onChange, onClose, placeholder, size, value, ...rest }, ref) => {
    const handleChange = useCallback(
      (event) => {
        onChange(event.target.value);
      },
      [onChange]
    );

    return (
      <InputGroup size={size} width="full" position="relative" {...rest}>
        <InputLeftElement pointerEvents="none">
          <Icon color="gray.100" as={FaSearch} />
        </InputLeftElement>
        <Input
          variant="filled"
          onChange={handleChange}
          placeholder={placeholder}
          ref={ref}
          disabled={disabled}
          value={value}
        />
        {onClose && (
          <InputRightElement>
            <IconButton
              onClick={onClose}
              color="gray.100"
              variant="ghost"
              size="xs"
              zIndex="0"
              icon={<Icon as={FaTimes} />}
            />
          </InputRightElement>
        )}
      </InputGroup>
    );
  }
);

SearchInput.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
  value: PropTypes.string,
};

SearchInput.defaultProps = {
  disabled: false,
  onClose: undefined,
  placeholder: "Search",
  size: "md",
  value: "",
};

export default memo(SearchInput);
